import React from "react";
import type { RootStore } from "./RootStore";
import type AppStore from "./AppStore";
import StoreContext from "./StoreContext";

export const useRootStore = (): RootStore => {
    const context = React.useContext(StoreContext);
    if (!context) {
        throw new Error("useRootStore must be used within StoreProvider");
    }
    return context;
};

export const useAppStore = (): AppStore => {
    const rootStore = useRootStore();
    return rootStore.appStore;
};

